import { IStyle } from '@fluentui/react';
import { IH2OTheme } from '@h2oai/ui-kit';

export interface IPendingReviewsStyles {
  root?: IStyle;
  header?: IStyle;
}

export interface IPendingReviewsClassNames {
  root: string;
  header: string;
}

export const pendingReviewsStylesDefault = (_theme: IH2OTheme): Partial<IPendingReviewsStyles> => ({
  root: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    minHeight: 0,
  },
  header: {},
});
